/* tslint:disable */
/* eslint-disable */
/**
 * GPS Application API
 * API for the GPS Application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Config
 */
export interface Config {
    /**
     * 
     * @type {any}
     * @memberof Config
     */
    'config_type'?: ConfigConfigTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof Config
     */
    'user': any;
    /**
     * 
     * @type {any}
     * @memberof Config
     */
    'password': any;
    /**
     * 
     * @type {any}
     * @memberof Config
     */
    'database'?: any;
    /**
     * 
     * @type {any}
     * @memberof Config
     */
    'api_key': any;
}

export const ConfigConfigTypeEnum = {
    Samsara: 'samsara'
} as const;

export type ConfigConfigTypeEnum = typeof ConfigConfigTypeEnum[keyof typeof ConfigConfigTypeEnum];

/**
 * Base response model.
 * @export
 * @interface ConnectionResponse
 */
export interface ConnectionResponse {
    /**
     * 
     * @type {number}
     * @memberof ConnectionResponse
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectionResponse
     */
    'organization_id': number;
    /**
     * 
     * @type {ConnectionType}
     * @memberof ConnectionResponse
     */
    'type': ConnectionType;
    /**
     * 
     * @type {Config}
     * @memberof ConnectionResponse
     */
    'config': Config;
    /**
     * 
     * @type {State}
     * @memberof ConnectionResponse
     */
    'state'?: State;
    /**
     * 
     * @type {ConnectionValidationStatus}
     * @memberof ConnectionResponse
     */
    'validation_status': ConnectionValidationStatus;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ConnectionType = {
    Geotab: 'geotab',
    Samsara: 'samsara'
} as const;

export type ConnectionType = typeof ConnectionType[keyof typeof ConnectionType];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ConnectionValidationStatus = {
    Unvalidated: 'unvalidated',
    Validated: 'validated',
    Invalid: 'invalid',
    Disabled: 'disabled'
} as const;

export type ConnectionValidationStatus = typeof ConnectionValidationStatus[keyof typeof ConnectionValidationStatus];


/**
 * Base response model.
 * @export
 * @interface CreateConnectionRequest
 */
export interface CreateConnectionRequest {
    /**
     * 
     * @type {ConnectionType}
     * @memberof CreateConnectionRequest
     */
    'type': ConnectionType;
    /**
     * 
     * @type {Config}
     * @memberof CreateConnectionRequest
     */
    'config': Config;
    /**
     * 
     * @type {State}
     * @memberof CreateConnectionRequest
     */
    'state'?: State;
    /**
     * 
     * @type {ConnectionValidationStatus}
     * @memberof CreateConnectionRequest
     */
    'validation_status': ConnectionValidationStatus;
}


/**
 * 
 * @export
 * @interface GeoFenceVisitAPIResponse
 */
export interface GeoFenceVisitAPIResponse {
    /**
     * 
     * @type {number}
     * @memberof GeoFenceVisitAPIResponse
     */
    'id': number;
    /**
     * 
     * @type {SavedTrackingDeviceWithDrivers}
     * @memberof GeoFenceVisitAPIResponse
     */
    'tracking_device': SavedTrackingDeviceWithDrivers;
    /**
     * 
     * @type {SavedGeoFenceWithLocation}
     * @memberof GeoFenceVisitAPIResponse
     */
    'geo_fence': SavedGeoFenceWithLocation;
    /**
     * 
     * @type {string}
     * @memberof GeoFenceVisitAPIResponse
     */
    'line': string;
    /**
     * 
     * @type {string}
     * @memberof GeoFenceVisitAPIResponse
     */
    'arrival': string;
    /**
     * 
     * @type {string}
     * @memberof GeoFenceVisitAPIResponse
     */
    'departure'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoFenceVisitAPIResponse
     */
    'last_ping': string;
}
/**
 * Configuration for Geotab GPS connection.
 * @export
 * @interface GeotabConfig
 */
export interface GeotabConfig {
    /**
     * 
     * @type {string}
     * @memberof GeotabConfig
     */
    'config_type'?: GeotabConfigConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GeotabConfig
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof GeotabConfig
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof GeotabConfig
     */
    'database'?: string;
}

export const GeotabConfigConfigTypeEnum = {
    Geotab: 'geotab'
} as const;

export type GeotabConfigConfigTypeEnum = typeof GeotabConfigConfigTypeEnum[keyof typeof GeotabConfigConfigTypeEnum];

/**
 * State information for Geotab GPS connection.
 * @export
 * @interface GeotabState
 */
export interface GeotabState {
    /**
     * 
     * @type {number}
     * @memberof GeotabState
     */
    'last_ping_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeotabState
     */
    'geotab_session_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeotabState
     */
    'geotab_server'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeotabState
     */
    'geotab_database'?: string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface PaginatedResponseGeoFenceVisitAPIResponse
 */
export interface PaginatedResponseGeoFenceVisitAPIResponse {
    /**
     * List of items for the current page
     * @type {Array<GeoFenceVisitAPIResponse>}
     * @memberof PaginatedResponseGeoFenceVisitAPIResponse
     */
    'items': Array<GeoFenceVisitAPIResponse>;
    /**
     * Cursor for the next page, None if no more items
     * @type {string}
     * @memberof PaginatedResponseGeoFenceVisitAPIResponse
     */
    'next_cursor'?: string;
    /**
     * Whether there are more items available
     * @type {boolean}
     * @memberof PaginatedResponseGeoFenceVisitAPIResponse
     */
    'has_more': boolean;
    /**
     * Number of items requested per page
     * @type {number}
     * @memberof PaginatedResponseGeoFenceVisitAPIResponse
     */
    'limit': number;
}
/**
 * 
 * @export
 * @interface Ping
 */
export interface Ping {
    /**
     * 
     * @type {string}
     * @memberof Ping
     */
    'time': string;
    /**
     * 
     * @type {number}
     * @memberof Ping
     */
    'recorded_speed_mph'?: number;
    /**
     * 
     * @type {number}
     * @memberof Ping
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof Ping
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof Ping
     */
    'tracking_device_id': number;
    /**
     * 
     * @type {number}
     * @memberof Ping
     */
    'organization_id': number;
}
/**
 * 
 * @export
 * @interface PolygonModel
 */
export interface PolygonModel {
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof PolygonModel
     */
    'exterior': Array<Array<string>>;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof PolygonModel
     */
    'interiors'?: Array<Array<any>>;
}
/**
 * Configuration for Samsara GPS connection.
 * @export
 * @interface SamsaraConfig
 */
export interface SamsaraConfig {
    /**
     * 
     * @type {string}
     * @memberof SamsaraConfig
     */
    'config_type'?: SamsaraConfigConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SamsaraConfig
     */
    'api_key': string;
}

export const SamsaraConfigConfigTypeEnum = {
    Samsara: 'samsara'
} as const;

export type SamsaraConfigConfigTypeEnum = typeof SamsaraConfigConfigTypeEnum[keyof typeof SamsaraConfigConfigTypeEnum];

/**
 * State information for Samsara GPS connection.
 * @export
 * @interface SamsaraState
 */
export interface SamsaraState {
    /**
     * 
     * @type {number}
     * @memberof SamsaraState
     */
    'last_ping_datetime'?: number;
}
/**
 * 
 * @export
 * @interface SavedDriver
 */
export interface SavedDriver {
    /**
     * 
     * @type {string}
     * @memberof SavedDriver
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SavedDriver
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedDriver
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof SavedDriver
     */
    'external_tracking_device_id': string;
    /**
     * 
     * @type {number}
     * @memberof SavedDriver
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedDriver
     */
    'tracking_device_id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedDriver
     */
    'organization_id': number;
}
/**
 * Model for saved geo fences with full location object instead of location_id
 * @export
 * @interface SavedGeoFenceWithLocation
 */
export interface SavedGeoFenceWithLocation {
    /**
     * 
     * @type {number}
     * @memberof SavedGeoFenceWithLocation
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof SavedGeoFenceWithLocation
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SavedGeoFenceWithLocation
     */
    'name': string;
    /**
     * 
     * @type {PolygonModel}
     * @memberof SavedGeoFenceWithLocation
     */
    'polygon': PolygonModel;
    /**
     * 
     * @type {SavedLocation}
     * @memberof SavedGeoFenceWithLocation
     */
    'location': SavedLocation;
}
/**
 * 
 * @export
 * @interface SavedLocation
 */
export interface SavedLocation {
    /**
     * 
     * @type {number}
     * @memberof SavedLocation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SavedLocation
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof SavedLocation
     */
    'deleted'?: boolean;
}
/**
 * 
 * @export
 * @interface SavedTrackingDevice
 */
export interface SavedTrackingDevice {
    /**
     * 
     * @type {string}
     * @memberof SavedTrackingDevice
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SavedTrackingDevice
     */
    'external_id': string;
    /**
     * 
     * @type {VehicleType}
     * @memberof SavedTrackingDevice
     */
    'vehicle_type': VehicleType;
    /**
     * 
     * @type {string}
     * @memberof SavedTrackingDevice
     */
    'license_plate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SavedTrackingDevice
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedTrackingDevice
     */
    'connection_id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedTrackingDevice
     */
    'organization_id': number;
}


/**
 * Tracking device model that includes driver information.
 * @export
 * @interface SavedTrackingDeviceWithDrivers
 */
export interface SavedTrackingDeviceWithDrivers {
    /**
     * 
     * @type {string}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'external_id': string;
    /**
     * 
     * @type {VehicleType}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'vehicle_type': VehicleType;
    /**
     * 
     * @type {string}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'license_plate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'connection_id': number;
    /**
     * 
     * @type {number}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'organization_id': number;
    /**
     * 
     * @type {Array<SavedDriver>}
     * @memberof SavedTrackingDeviceWithDrivers
     */
    'drivers'?: Array<SavedDriver>;
}


/**
 * 
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {any}
     * @memberof State
     */
    'last_ping_version'?: any;
    /**
     * 
     * @type {any}
     * @memberof State
     */
    'geotab_session_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof State
     */
    'geotab_server'?: any;
    /**
     * 
     * @type {any}
     * @memberof State
     */
    'geotab_database'?: any;
    /**
     * 
     * @type {any}
     * @memberof State
     */
    'last_ping_datetime'?: any;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const VehicleType = {
    Tractor: 'tractor',
    Chassis: 'chassis'
} as const;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];



/**
 * ConnectionsApi - axios parameter creator
 * @export
 */
export const ConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new connection.
         * @summary Create Connection
         * @param {CreateConnectionRequest} createConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectionConnectionsPost: async (createConnectionRequest: CreateConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConnectionRequest' is not null or undefined
            assertParamExists('createConnectionConnectionsPost', 'createConnectionRequest', createConnectionRequest)
            const localVarPath = `/connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a connection by ID.
         * @summary Delete Connection
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnectionConnectionsConnectionIdDelete: async (connectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('deleteConnectionConnectionsConnectionIdDelete', 'connectionId', connectionId)
            const localVarPath = `/connections/{connection_id}/`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all connections.
         * @summary Get All Connections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConnectionsConnectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a connection by ID.
         * @summary Get Connection
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionConnectionsConnectionIdGet: async (connectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('getConnectionConnectionsConnectionIdGet', 'connectionId', connectionId)
            const localVarPath = `/connections/{connection_id}/`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectionsApi - functional programming interface
 * @export
 */
export const ConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new connection.
         * @summary Create Connection
         * @param {CreateConnectionRequest} createConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnectionConnectionsPost(createConnectionRequest: CreateConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectionConnectionsPost(createConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.createConnectionConnectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a connection by ID.
         * @summary Delete Connection
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConnectionConnectionsConnectionIdDelete(connectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConnectionConnectionsConnectionIdDelete(connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.deleteConnectionConnectionsConnectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all connections.
         * @summary Get All Connections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConnectionsConnectionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConnectionsConnectionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.getAllConnectionsConnectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a connection by ID.
         * @summary Get Connection
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionConnectionsConnectionIdGet(connectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionConnectionsConnectionIdGet(connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectionsApi.getConnectionConnectionsConnectionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectionsApi - factory interface
 * @export
 */
export const ConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectionsApiFp(configuration)
    return {
        /**
         * Create a new connection.
         * @summary Create Connection
         * @param {CreateConnectionRequest} createConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectionConnectionsPost(createConnectionRequest: CreateConnectionRequest, options?: any): AxiosPromise<ConnectionResponse> {
            return localVarFp.createConnectionConnectionsPost(createConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a connection by ID.
         * @summary Delete Connection
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnectionConnectionsConnectionIdDelete(connectionId: number, options?: any): AxiosPromise<ConnectionResponse> {
            return localVarFp.deleteConnectionConnectionsConnectionIdDelete(connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all connections.
         * @summary Get All Connections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConnectionsConnectionsGet(options?: any): AxiosPromise<Array<ConnectionResponse>> {
            return localVarFp.getAllConnectionsConnectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a connection by ID.
         * @summary Get Connection
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionConnectionsConnectionIdGet(connectionId: number, options?: any): AxiosPromise<ConnectionResponse> {
            return localVarFp.getConnectionConnectionsConnectionIdGet(connectionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConnectionsApi - object-oriented interface
 * @export
 * @class ConnectionsApi
 * @extends {BaseAPI}
 */
export class ConnectionsApi extends BaseAPI {
    /**
     * Create a new connection.
     * @summary Create Connection
     * @param {CreateConnectionRequest} createConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public createConnectionConnectionsPost(createConnectionRequest: CreateConnectionRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).createConnectionConnectionsPost(createConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a connection by ID.
     * @summary Delete Connection
     * @param {number} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public deleteConnectionConnectionsConnectionIdDelete(connectionId: number, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).deleteConnectionConnectionsConnectionIdDelete(connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all connections.
     * @summary Get All Connections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getAllConnectionsConnectionsGet(options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getAllConnectionsConnectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a connection by ID.
     * @summary Get Connection
     * @param {number} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getConnectionConnectionsConnectionIdGet(connectionId: number, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getConnectionConnectionsConnectionIdGet(connectionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeoFencesApi - axios parameter creator
 * @export
 */
export const GeoFencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all geo fences.
         * @summary Get All Geo Fences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGeoFencesGeoFencesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/geo_fences/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a geo fence by ID.
         * @summary Get Geo Fence
         * @param {number} geoFenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoFenceGeoFencesGeoFenceIdGet: async (geoFenceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'geoFenceId' is not null or undefined
            assertParamExists('getGeoFenceGeoFencesGeoFenceIdGet', 'geoFenceId', geoFenceId)
            const localVarPath = `/geo_fences/{geo_fence_id}/`
                .replace(`{${"geo_fence_id"}}`, encodeURIComponent(String(geoFenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeoFencesApi - functional programming interface
 * @export
 */
export const GeoFencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeoFencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all geo fences.
         * @summary Get All Geo Fences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGeoFencesGeoFencesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SavedGeoFenceWithLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGeoFencesGeoFencesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoFencesApi.getAllGeoFencesGeoFencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a geo fence by ID.
         * @summary Get Geo Fence
         * @param {number} geoFenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeoFenceGeoFencesGeoFenceIdGet(geoFenceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SavedGeoFenceWithLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeoFenceGeoFencesGeoFenceIdGet(geoFenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoFencesApi.getGeoFenceGeoFencesGeoFenceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeoFencesApi - factory interface
 * @export
 */
export const GeoFencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeoFencesApiFp(configuration)
    return {
        /**
         * Get all geo fences.
         * @summary Get All Geo Fences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGeoFencesGeoFencesGet(options?: any): AxiosPromise<Array<SavedGeoFenceWithLocation>> {
            return localVarFp.getAllGeoFencesGeoFencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a geo fence by ID.
         * @summary Get Geo Fence
         * @param {number} geoFenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoFenceGeoFencesGeoFenceIdGet(geoFenceId: number, options?: any): AxiosPromise<SavedGeoFenceWithLocation> {
            return localVarFp.getGeoFenceGeoFencesGeoFenceIdGet(geoFenceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeoFencesApi - object-oriented interface
 * @export
 * @class GeoFencesApi
 * @extends {BaseAPI}
 */
export class GeoFencesApi extends BaseAPI {
    /**
     * Get all geo fences.
     * @summary Get All Geo Fences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoFencesApi
     */
    public getAllGeoFencesGeoFencesGet(options?: RawAxiosRequestConfig) {
        return GeoFencesApiFp(this.configuration).getAllGeoFencesGeoFencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a geo fence by ID.
     * @summary Get Geo Fence
     * @param {number} geoFenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoFencesApi
     */
    public getGeoFenceGeoFencesGeoFenceIdGet(geoFenceId: number, options?: RawAxiosRequestConfig) {
        return GeoFencesApiFp(this.configuration).getGeoFenceGeoFencesGeoFenceIdGet(geoFenceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all locations.
         * @summary Get All Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocationsLocationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a location by ID.
         * @summary Get Location
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationLocationsLocationIdGet: async (locationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationLocationsLocationIdGet', 'locationId', locationId)
            const localVarPath = `/locations/{location_id}/`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all locations.
         * @summary Get All Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLocationsLocationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SavedLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLocationsLocationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getAllLocationsLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a location by ID.
         * @summary Get Location
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationLocationsLocationIdGet(locationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SavedLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationLocationsLocationIdGet(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationLocationsLocationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * Get all locations.
         * @summary Get All Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocationsLocationsGet(options?: any): AxiosPromise<Array<SavedLocation>> {
            return localVarFp.getAllLocationsLocationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a location by ID.
         * @summary Get Location
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationLocationsLocationIdGet(locationId: number, options?: any): AxiosPromise<SavedLocation> {
            return localVarFp.getLocationLocationsLocationIdGet(locationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * Get all locations.
     * @summary Get All Locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getAllLocationsLocationsGet(options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getAllLocationsLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a location by ID.
     * @summary Get Location
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationLocationsLocationIdGet(locationId: number, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationLocationsLocationIdGet(locationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingsApi - axios parameter creator
 * @export
 */
export const PingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all pings for a specific tracking device.
         * @summary Get Pings By Device
         * @param {number} deviceId 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPingsByDevicePingsByDeviceDeviceIdGet: async (deviceId: number, fromTime: string, toTime: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getPingsByDevicePingsByDeviceDeviceIdGet', 'deviceId', deviceId)
            // verify required parameter 'fromTime' is not null or undefined
            assertParamExists('getPingsByDevicePingsByDeviceDeviceIdGet', 'fromTime', fromTime)
            // verify required parameter 'toTime' is not null or undefined
            assertParamExists('getPingsByDevicePingsByDeviceDeviceIdGet', 'toTime', toTime)
            const localVarPath = `/pings/by_device/{device_id}/`
                .replace(`{${"device_id"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromTime !== undefined) {
                localVarQueryParameter['from_time'] = (fromTime as any instanceof Date) ?
                    (fromTime as any).toISOString() :
                    fromTime;
            }

            if (toTime !== undefined) {
                localVarQueryParameter['to_time'] = (toTime as any instanceof Date) ?
                    (toTime as any).toISOString() :
                    toTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingsApi - functional programming interface
 * @export
 */
export const PingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all pings for a specific tracking device.
         * @summary Get Pings By Device
         * @param {number} deviceId 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPingsByDevicePingsByDeviceDeviceIdGet(deviceId: number, fromTime: string, toTime: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ping>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPingsByDevicePingsByDeviceDeviceIdGet(deviceId, fromTime, toTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingsApi.getPingsByDevicePingsByDeviceDeviceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingsApi - factory interface
 * @export
 */
export const PingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingsApiFp(configuration)
    return {
        /**
         * Get all pings for a specific tracking device.
         * @summary Get Pings By Device
         * @param {number} deviceId 
         * @param {string} fromTime 
         * @param {string} toTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPingsByDevicePingsByDeviceDeviceIdGet(deviceId: number, fromTime: string, toTime: string, options?: any): AxiosPromise<Array<Ping>> {
            return localVarFp.getPingsByDevicePingsByDeviceDeviceIdGet(deviceId, fromTime, toTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingsApi - object-oriented interface
 * @export
 * @class PingsApi
 * @extends {BaseAPI}
 */
export class PingsApi extends BaseAPI {
    /**
     * Get all pings for a specific tracking device.
     * @summary Get Pings By Device
     * @param {number} deviceId 
     * @param {string} fromTime 
     * @param {string} toTime 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingsApi
     */
    public getPingsByDevicePingsByDeviceDeviceIdGet(deviceId: number, fromTime: string, toTime: string, options?: RawAxiosRequestConfig) {
        return PingsApiFp(this.configuration).getPingsByDevicePingsByDeviceDeviceIdGet(deviceId, fromTime, toTime, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrackingDevicesApi - axios parameter creator
 * @export
 */
export const TrackingDevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get tracking devices with optional filters.
         * @summary Get Tracking Devices
         * @param {string} [deviceIds] Comma-separated list of device IDs
         * @param {string} [connectionIds] Comma-separated list of connection IDs
         * @param {string} [externalIds] Comma-separated list of external IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingDevicesTrackingDevicesGet: async (deviceIds?: string, connectionIds?: string, externalIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tracking_devices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceIds !== undefined) {
                localVarQueryParameter['device_ids'] = deviceIds;
            }

            if (connectionIds !== undefined) {
                localVarQueryParameter['connection_ids'] = connectionIds;
            }

            if (externalIds !== undefined) {
                localVarQueryParameter['external_ids'] = externalIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingDevicesApi - functional programming interface
 * @export
 */
export const TrackingDevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackingDevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get tracking devices with optional filters.
         * @summary Get Tracking Devices
         * @param {string} [deviceIds] Comma-separated list of device IDs
         * @param {string} [connectionIds] Comma-separated list of connection IDs
         * @param {string} [externalIds] Comma-separated list of external IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackingDevicesTrackingDevicesGet(deviceIds?: string, connectionIds?: string, externalIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SavedTrackingDevice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackingDevicesTrackingDevicesGet(deviceIds, connectionIds, externalIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingDevicesApi.getTrackingDevicesTrackingDevicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrackingDevicesApi - factory interface
 * @export
 */
export const TrackingDevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackingDevicesApiFp(configuration)
    return {
        /**
         * Get tracking devices with optional filters.
         * @summary Get Tracking Devices
         * @param {string} [deviceIds] Comma-separated list of device IDs
         * @param {string} [connectionIds] Comma-separated list of connection IDs
         * @param {string} [externalIds] Comma-separated list of external IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingDevicesTrackingDevicesGet(deviceIds?: string, connectionIds?: string, externalIds?: string, options?: any): AxiosPromise<Array<SavedTrackingDevice>> {
            return localVarFp.getTrackingDevicesTrackingDevicesGet(deviceIds, connectionIds, externalIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackingDevicesApi - object-oriented interface
 * @export
 * @class TrackingDevicesApi
 * @extends {BaseAPI}
 */
export class TrackingDevicesApi extends BaseAPI {
    /**
     * Get tracking devices with optional filters.
     * @summary Get Tracking Devices
     * @param {string} [deviceIds] Comma-separated list of device IDs
     * @param {string} [connectionIds] Comma-separated list of connection IDs
     * @param {string} [externalIds] Comma-separated list of external IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingDevicesApi
     */
    public getTrackingDevicesTrackingDevicesGet(deviceIds?: string, connectionIds?: string, externalIds?: string, options?: RawAxiosRequestConfig) {
        return TrackingDevicesApiFp(this.configuration).getTrackingDevicesTrackingDevicesGet(deviceIds, connectionIds, externalIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VisitsApi - axios parameter creator
 * @export
 */
export const VisitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a visit by ID.
         * @summary Get Geo Fence Visit
         * @param {number} visitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoFenceVisitVisitsVisitIdGet: async (visitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('getGeoFenceVisitVisitsVisitIdGet', 'visitId', visitId)
            const localVarPath = `/visits/{visit_id}/`
                .replace(`{${"visit_id"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get visits with cursor-based pagination, optionally filtered by device ID.
         * @summary Get Visits
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {string} [deviceIds] Comma-separated list of device IDs
         * @param {string} [externalDeviceIds] Comma-separated list of external device IDs
         * @param {string} [locationIds] Comma-separated list of location IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitsVisitsGet: async (beforeCursor?: string, limit?: number, deviceIds?: string, externalDeviceIds?: string, locationIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/visits/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeCursor !== undefined) {
                localVarQueryParameter['before_cursor'] = beforeCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (deviceIds !== undefined) {
                localVarQueryParameter['device_ids'] = deviceIds;
            }

            if (externalDeviceIds !== undefined) {
                localVarQueryParameter['external_device_ids'] = externalDeviceIds;
            }

            if (locationIds !== undefined) {
                localVarQueryParameter['location_ids'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitsApi - functional programming interface
 * @export
 */
export const VisitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a visit by ID.
         * @summary Get Geo Fence Visit
         * @param {number} visitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeoFenceVisitVisitsVisitIdGet(visitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeoFenceVisitAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeoFenceVisitVisitsVisitIdGet(visitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitsApi.getGeoFenceVisitVisitsVisitIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get visits with cursor-based pagination, optionally filtered by device ID.
         * @summary Get Visits
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {string} [deviceIds] Comma-separated list of device IDs
         * @param {string} [externalDeviceIds] Comma-separated list of external device IDs
         * @param {string} [locationIds] Comma-separated list of location IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitsVisitsGet(beforeCursor?: string, limit?: number, deviceIds?: string, externalDeviceIds?: string, locationIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseGeoFenceVisitAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitsVisitsGet(beforeCursor, limit, deviceIds, externalDeviceIds, locationIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitsApi.getVisitsVisitsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VisitsApi - factory interface
 * @export
 */
export const VisitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitsApiFp(configuration)
    return {
        /**
         * Get a visit by ID.
         * @summary Get Geo Fence Visit
         * @param {number} visitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoFenceVisitVisitsVisitIdGet(visitId: number, options?: any): AxiosPromise<GeoFenceVisitAPIResponse> {
            return localVarFp.getGeoFenceVisitVisitsVisitIdGet(visitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get visits with cursor-based pagination, optionally filtered by device ID.
         * @summary Get Visits
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {string} [deviceIds] Comma-separated list of device IDs
         * @param {string} [externalDeviceIds] Comma-separated list of external device IDs
         * @param {string} [locationIds] Comma-separated list of location IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitsVisitsGet(beforeCursor?: string, limit?: number, deviceIds?: string, externalDeviceIds?: string, locationIds?: string, options?: any): AxiosPromise<PaginatedResponseGeoFenceVisitAPIResponse> {
            return localVarFp.getVisitsVisitsGet(beforeCursor, limit, deviceIds, externalDeviceIds, locationIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VisitsApi - object-oriented interface
 * @export
 * @class VisitsApi
 * @extends {BaseAPI}
 */
export class VisitsApi extends BaseAPI {
    /**
     * Get a visit by ID.
     * @summary Get Geo Fence Visit
     * @param {number} visitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitsApi
     */
    public getGeoFenceVisitVisitsVisitIdGet(visitId: number, options?: RawAxiosRequestConfig) {
        return VisitsApiFp(this.configuration).getGeoFenceVisitVisitsVisitIdGet(visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get visits with cursor-based pagination, optionally filtered by device ID.
     * @summary Get Visits
     * @param {string} [beforeCursor] 
     * @param {number} [limit] 
     * @param {string} [deviceIds] Comma-separated list of device IDs
     * @param {string} [externalDeviceIds] Comma-separated list of external device IDs
     * @param {string} [locationIds] Comma-separated list of location IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitsApi
     */
    public getVisitsVisitsGet(beforeCursor?: string, limit?: number, deviceIds?: string, externalDeviceIds?: string, locationIds?: string, options?: RawAxiosRequestConfig) {
        return VisitsApiFp(this.configuration).getVisitsVisitsGet(beforeCursor, limit, deviceIds, externalDeviceIds, locationIds, options).then((request) => request(this.axios, this.basePath));
    }
}



